export default __webpack_public_path__ + "assets/guy-with-dog-a5ecce8f1271dbae25fa75207c2fe66f.png";